import { useContext } from 'react';
import AuthContext, { AuthContextValue } from 'src/contexts/JWTAuthContext';

const useAuth = () => useContext<AuthContextValue>(AuthContext);

export default useAuth;
